import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
//**Modules import */

import loginModule from "./Modules/login";
import initAuthModule from "./Modules/initAuth";
import watchSignalR from "./Modules/watch";
import moduleTestSignalR from "./Modules/signalR";

export const store = new Vuex.Store({
  modules: {
    loginModule,
    initAuthModule,
    watchSignalR,
    moduleTestSignalR
  },
  state: {
    message: ""
  },
  mutations: {
    setMessage(state, message) {
      state.message = message;
    }
  },
  actions: {
    setTimeoutTimer({ dispatch }, expiresIn) {
      setTimeout(() => {
        dispatch("logout");
      }, expiresIn);
    }
  },
  getters: {
    getMessage(state) {
      return state.message;
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js